import React from 'react';

const ControlValveGrayFittingIcon = ({
  width = 64,
  height = 64,
  className = '',
  startColor = '#373737',
  midColor = '#EBEBEB',
  endColor = '#373737'
}) => {
  const uid = React.useId ? React.useId() : 'sc' + Math.random().toString(36).substr(2, 9);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 39.53 112.5"
      className={className}
    >

<g id={`${uid}_1`}>
	<linearGradient id={`${uid}_2`} gradientUnits="userSpaceOnUse" x1="5.6309" y1="96.5088" x2="5.6309" y2="86.5996">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_2)`} d="M9.798,96.509H3.266l-1.802-1.802v-6.531L3.266,86.6h6.532V96.509" />
	<linearGradient id={`${uid}_3`} gradientUnits="userSpaceOnUse" x1="13.1758" y1="69.1855" x2="26.2393" y2="69.1855">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.73" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_3)`} d="M13.176,67.455h13.063v3.462H13.176V67.455z" />
	<path fill={`${endColor}`} d="M10.924,82.875h17.342v1.543H10.924V82.875z" />
	<path fill={`${startColor}`} d="M14.753,64.302h9.909v2.478h-9.909V64.302z" />
	<path fill={`${startColor}`} d="M15.653,66.779h8.108v0.676h-8.108V66.779z" />
	<path fill={`${midColor}`} d="M9.798,84.121h19.819v14.865H9.798V84.121z" />
	<linearGradient id={`${uid}_4`} gradientUnits="userSpaceOnUse" x1="13.1758" y1="106.5313" x2="26.2393" y2="106.5313">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_4)`} d="M13.176,100.563h13.063V112.5H13.176V100.563z" />
	<path fill={`${endColor}`} d="M16.779,84.121h5.856v2.703h-5.856V84.121z" />
	<linearGradient id={`${uid}_5`} gradientUnits="userSpaceOnUse" x1="9.7979" y1="108.7832" x2="29.6172" y2="108.7832">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_5)`} d="M9.798,107.095h19.819v3.378H9.798V107.095z" />
	<linearGradient id={`${uid}_6`} gradientUnits="userSpaceOnUse" x1="11.374" y1="99.7744" x2="28.041" y2="99.7744">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_6)`} d="M11.374,98.986h16.667v1.576H11.374V98.986" />
	<linearGradient id={`${uid}_7`} gradientUnits="userSpaceOnUse" x1="13.1758" y1="76.8926" x2="26.2393" y2="76.8926">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_7)`} d="M13.176,72.41h13.063v8.965H13.176V72.41" />
	<linearGradient id={`${uid}_8`} gradientUnits="userSpaceOnUse" x1="9.7979" y1="81.9824" x2="29.6172" y2="81.9824">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_8)`} d="M9.798,80.743h19.819v2.478H9.798V80.743" />
	<linearGradient id={`${uid}_9`} gradientUnits="userSpaceOnUse" x1="13.8516" y1="106.3066" x2="16.3291" y2="106.3066">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.5" style={{stopColor: `${midColor}`}} />
		<stop offset="0.57" style={{stopColor: `${midColor}`}} />
		<stop offset="0.71" style={{stopColor: `${midColor}`}} />
		<stop offset="0.92" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_9)`} d="M13.852,105.518h2.478v1.577h-2.478V105.518z" />
	<linearGradient id={`${uid}_10`} gradientUnits="userSpaceOnUse" x1="23.0859" y1="106.3066" x2="25.3379" y2="106.3066">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.5" style={{stopColor: `${midColor}`}} />
		<stop offset="0.57" style={{stopColor: `${midColor}`}} />
		<stop offset="0.71" style={{stopColor: `${midColor}`}} />
		<stop offset="0.92" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_10)`} d="M23.086,105.518h2.252v1.577h-2.252V105.518z" />
	<linearGradient id={`${uid}_11`} gradientUnits="userSpaceOnUse" x1="18.3564" y1="106.3066" x2="20.834" y2="106.3066">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.5" style={{stopColor: `${midColor}`}} />
		<stop offset="0.57" style={{stopColor: `${midColor}`}} />
		<stop offset="0.71" style={{stopColor: `${midColor}`}} />
		<stop offset="0.92" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_11)`} d="M18.356,105.518h2.478v1.577h-2.478V105.518z" />
	<linearGradient id={`${uid}_12`} gradientUnits="userSpaceOnUse" x1="26.6895" y1="106.3066" x2="29.167" y2="106.3066">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.5" style={{stopColor: `${midColor}`}} />
		<stop offset="0.57" style={{stopColor: `${midColor}`}} />
		<stop offset="0.71" style={{stopColor: `${midColor}`}} />
		<stop offset="0.92" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_12)`} d="M26.689,105.518h2.478v1.577h-2.478V105.518z" />
	<linearGradient id={`${uid}_13`} gradientUnits="userSpaceOnUse" x1="10.248" y1="106.3066" x2="12.7256" y2="106.3066">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.5" style={{stopColor: `${midColor}`}} />
		<stop offset="0.57" style={{stopColor: `${midColor}`}} />
		<stop offset="0.71" style={{stopColor: `${midColor}`}} />
		<stop offset="0.92" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_13)`} d="M10.248,105.518h2.478v1.577h-2.478V105.518z" />
	<linearGradient id={`${uid}_14`} gradientUnits="userSpaceOnUse" x1="13.8516" y1="79.9551" x2="16.3291" y2="79.9551">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.5" style={{stopColor: `${midColor}`}} />
		<stop offset="0.57" style={{stopColor: `${midColor}`}} />
		<stop offset="0.71" style={{stopColor: `${midColor}`}} />
		<stop offset="0.92" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_14)`} d="M13.852,79.166h2.478v1.577h-2.478V79.166z" />
	<linearGradient id={`${uid}_15`} gradientUnits="userSpaceOnUse" x1="23.0859" y1="79.9551" x2="25.3379" y2="79.9551">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.5" style={{stopColor: `${midColor}`}} />
		<stop offset="0.57" style={{stopColor: `${midColor}`}} />
		<stop offset="0.71" style={{stopColor: `${midColor}`}} />
		<stop offset="0.92" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_15)`} d="M23.086,79.166h2.252v1.577h-2.252V79.166z" />
	<linearGradient id={`${uid}_16`} gradientUnits="userSpaceOnUse" x1="18.3564" y1="79.9551" x2="20.834" y2="79.9551">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.5" style={{stopColor: `${midColor}`}} />
		<stop offset="0.57" style={{stopColor: `${midColor}`}} />
		<stop offset="0.71" style={{stopColor: `${midColor}`}} />
		<stop offset="0.92" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_16)`} d="M18.356,79.166h2.478v1.577h-2.478V79.166z" />
	<linearGradient id={`${uid}_17`} gradientUnits="userSpaceOnUse" x1="26.6895" y1="79.9551" x2="29.167" y2="79.9551">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.5" style={{stopColor: `${midColor}`}} />
		<stop offset="0.57" style={{stopColor: `${midColor}`}} />
		<stop offset="0.71" style={{stopColor: `${midColor}`}} />
		<stop offset="0.92" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_17)`} d="M26.689,79.166h2.478v1.577h-2.478V79.166z" />
	<linearGradient id={`${uid}_18`} gradientUnits="userSpaceOnUse" x1="10.248" y1="79.9551" x2="12.7256" y2="79.9551">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.5" style={{stopColor: `${midColor}`}} />
		<stop offset="0.57" style={{stopColor: `${midColor}`}} />
		<stop offset="0.71" style={{stopColor: `${midColor}`}} />
		<stop offset="0.92" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_18)`} d="M10.248,79.166h2.478v1.577h-2.478V79.166z" />
	
		<radialGradient id={`${uid}_19`} cx="2.3647" cy="91.5547" r="3.5605" gradientTransform="matrix(1 0 0 1.2 0 -18.3109)" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: `${midColor}`}} />
		<stop offset="0.14" style={{stopColor: `${midColor}`}} />
		<stop offset="0.4" style={{stopColor: `${midColor}`}} />
		<stop offset="0.75" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</radialGradient>
	<path fill={`url(#${uid}_19)`} d="M3.266,96.509l-1.802-1.802v-6.531L3.266,86.6" />
	<linearGradient id={`${uid}_20`} gradientUnits="userSpaceOnUse" x1="2.3647" y1="96.5088" x2="2.3647" y2="86.5996">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.62" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_20)`} d="M3.266,96.509l-1.802-1.802v-6.531L3.266,86.6" />
</g>
<g id={`${uid}_21`}>
	<linearGradient id={`${uid}_22`} gradientUnits="userSpaceOnUse" x1="18.3564" y1="55.5732" x2="20.834" y2="55.5732">
		<stop offset="0" style={{stopColor: `${midColor}`}} />
		<stop offset="0.5" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${midColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_22)`} d="M18.356,46.834h2.478v17.478h-2.478V46.834z" />
	<path fill={`${midColor}`} d="M19.257,47.635h0.901V63.4h-0.901V47.635z" />
	<path fill={`${startColor}`} d="M18.131,57.085h3.153v2.262h-3.153V57.085z" />
</g>
<g id={`${uid}_23`}>
	<path fill={`${startColor}`} d="M17.23,51.915h4.954v5.292H17.23V51.915z" />
	<path fill={`${startColor}`} d="M15.653,56.869h8.108v0.676h-8.108V56.869z" />
</g>
<g id={`${uid}_24`}>
	
		<linearGradient id={`${uid}_25`} gradientUnits="userSpaceOnUse" x1="9.772" y1="55.0933" x2="29.5762" y2="55.0933" gradientTransform="matrix(1 -0.0066 0.0066 1 -0.2236 0.3506)">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.06" style={{stopColor: `${endColor}`}} />
		<stop offset="0.08" style={{stopColor: `${endColor}`}} />
		<stop offset="0.12" style={{stopColor: `${endColor}`}} />
		<stop offset="0.15" style={{stopColor: `${startColor}`}} />
		<stop offset="0.52" style={{stopColor: `${endColor}`}} />
		<stop offset="0.82" style={{stopColor: `${startColor}`}} />
		<stop offset="0.94" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_25)`} d="M10.084,40.836l3.204-2.619l0.378,2.416l-1.543,0.92l0.023,28.429l3.606,0.427l10.924-0.072   l0.897-0.456l-0.073-28.266l-1.584-1.003l-0.242-2.476l3.942,2.364l0.097,29.883l-0.547,1.18l-2.928,0.848l-12.95,0.043   l-2.708-0.884l-0.57-1.009L10.084,40.836z" />
</g>
<g id={`${uid}_26`}>
	<linearGradient id={`${uid}_27`} gradientUnits="userSpaceOnUse" x1="9.7979" y1="26.9111" x2="29.6172" y2="26.9111">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.73" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_27)`} d="M9.798,15.653l2.478,1.576L13.099,39.5l0.527,1.491l0.226,0.112l0,0l0,0h11.824l0,0l0.226-0.112   l0.338-1.464l0.9-22.297l2.478-1.576v-2.81L9.798,12.719V15.653z" />
	<linearGradient id={`${uid}_28`} gradientUnits="userSpaceOnUse" x1="37.0498" y1="6.416" x2="38.626" y2="6.416">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.73" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_28)`} d="M37.05,8.891h1.576V3.941H37.05V8.891z" />
	<linearGradient id={`${uid}_29`} gradientUnits="userSpaceOnUse" x1="3.2656" y1="2.6396" x2="36.1484" y2="2.6396">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.73" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_29)`} d="M36.148,1.596V5.28H3.266V1.596l0.451-1.105L4.617,0h1.239h28.716l1.126,0.491L36.148,1.596z" />
	<path fill={`${startColor}`} d="M14.753,41.104h9.909v0.901h-9.909V41.104z" />
	<path fill={`${startColor}`} d="M17.23,41.554h4.954v5.406H17.23V41.554z" />
	<linearGradient id={`${uid}_30`} gradientUnits="userSpaceOnUse" x1="0.7881" y1="6.416" x2="2.3652" y2="6.416">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.73" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_30)`} d="M0.788,8.891h1.577V3.941H0.788V8.891z" />
	<linearGradient id={`${uid}_31`} gradientUnits="userSpaceOnUse" x1="3.2656" y1="10.4629" x2="36.1484" y2="10.4629">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.73" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_31)`} d="M3.266,11.203V7.75h32.883v3.453l-0.45,1.356l-0.788,0.617h-1.238H4.843l-1.126-0.617L3.266,11.203   z" />
	<linearGradient id={`${uid}_32`} gradientUnits="userSpaceOnUse" x1="18.8066" y1="6.416" x2="20.6084" y2="6.416">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.73" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_32)`} d="M18.807,8.891h1.802V3.941h-1.802V8.891z" />
	<linearGradient id={`${uid}_33`} gradientUnits="userSpaceOnUse" x1="6.4189" y1="6.416" x2="8.2207" y2="6.416">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.73" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_33)`} d="M6.419,8.891h1.802V3.941H6.419V8.891z" />
	<linearGradient id={`${uid}_34`} gradientUnits="userSpaceOnUse" x1="12.2754" y1="6.416" x2="13.8516" y2="6.416">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.73" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_34)`} d="M12.275,8.891h1.576V3.941h-1.576V8.891z" />
	<linearGradient id={`${uid}_35`} gradientUnits="userSpaceOnUse" x1="25.3379" y1="6.416" x2="27.1396" y2="6.416">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.73" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_35)`} d="M25.338,8.891h1.802V3.941h-1.802V8.891z" />
	<linearGradient id={`${uid}_36`} gradientUnits="userSpaceOnUse" x1="31.1943" y1="6.416" x2="32.9961" y2="6.416">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.73" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_36)`} d="M31.194,8.891h1.802V3.941h-1.802V8.891z" />
	<linearGradient id={`${uid}_37`} gradientUnits="userSpaceOnUse" x1="0" y1="5.6309" x2="39.5273" y2="5.6309">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.73" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_37)`} d="M0,4.842h39.527v1.577H0V4.842z" />
	<path fill={`${startColor}`} d="M12.275,17.229l-2.478-1.576h19.819l-2.478,1.576H12.275z" />
	<linearGradient id={`${uid}_38`} gradientUnits="userSpaceOnUse" x1="0" y1="7.3198" x2="39.5273" y2="7.3198">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.73" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_38)`} d="M0,6.419h39.527v1.802H0V6.419z" />
	<path fill={`${endColor}`} d="M23.762,31.338c0-0.9-0.694-1.631-1.576-1.707V29.62c0,0-4.799-0.003-4.811-0.003   c-0.951,0-1.722,0.771-1.722,1.722c0,0.951,0.771,1.722,1.722,1.722c0.012,0,4.811-0.015,4.811-0.015   C23.067,32.97,23.762,32.239,23.762,31.338z" />
	<circle fill={`${startColor}`} cx="22.185" cy="31.194" r="0.45" />
	<circle fill={`${startColor}`} cx="17.23" cy="31.194" r="0.45" />
	<rect y="6.21" fill={`${startColor}`} width="39.53" height="0.417" />
</g>
    </svg>
  );
};

export default ControlValveGrayFittingIcon;
